module.exports = __webpack_public_path__ + "img/gb5784-86-m12x55.prt.4e82ab44.jpg";